// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/dropdown/dropdown.css
// module id = 2005
// module chunks = 0